import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import * as Popper from 'popper.js/dist/umd/popper';
import {StocksHelper} from "../../models/stocks-helper";
import {ColumnSelector} from "../../models/column-selector";
import {AggregationSelector, Aggregation} from "../../models/aggregation-selector";

@Component({
    selector: 'ag-select-list',
    templateUrl: './ag-select-list.component.html',
    styleUrls: ['./ag-select-list.component.css']
})
export class AgSelectListComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
                private filterService: StocksFilterService){


        this.helper = new StocksHelper();
        this.close = new EventEmitter<{type: string, data: ColumnSelector[] | AggregationSelector[]}>();
        this.show = false;
        this.selected = [];
        this.groupingList = [];
        this.aggregationList = [];
    }

    private initialise = (): void =>{

    };

    @Input() private columns: Slick.Column<any>[];
    @Input() private grouping?: any[] | AggregationSelector[];
    @Input() private type: string;
    @Input() private addRef: ElementRef;
    @Input() private wrpRef: ElementRef;

    @Input() set updatePopper(val: number){
        console.log('updatePopper')
        this.popperAddVar ? this.popperAddVar.update() : null;

    };

    //Resize grid when dimensions of window changeng
    @HostListener('window:resize')
    resize = (): void =>{
        if (this.popperAddVar)
            this.popperAddVar.update();
    }

    @Output()
    private readonly close: EventEmitter<{type: string, data: ColumnSelector[] | AggregationSelector[]}>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    private helper: StocksHelper;
    private popperAddVar: Popper;
    public show: boolean;
    public selected: ColumnSelector[] | AggregationSelector[];

    private groupingList: ColumnSelector[];
    private aggregationList: AggregationSelector[];
    private listenMouseDown: () => void;

    ngOnInit(){
        //# generate list of grouping or aggregations
        if (this.type === 'grouping') {
            this.selected = (this.grouping as any[]).map(item => new ColumnSelector(item.getter, item.name, true));
            let groupingColumns = this.columns.filter(c => c.grouping)
            this.groupingList = groupingColumns.map(item => {
                return new ColumnSelector(item.id, item.name, item.grouping.grouped);
            });

            (this.grouping as any[]).forEach(item => {
                this.groupingList.forEach(inItem => {
                    if (item.getter === inItem.id) {
                        inItem.selected = true;
                    }
                })
            });
        } else if (this.type === 'aggregation') {
            this.aggregationList = this.columns.filter(item => item.type === 'number' && item.grouping && item.grouping.aggregation)
                .map(item => item.grouping.aggregation)
                .map(item => this.helper.copyAggregatorSelector(item));
        }
    }

    ngOnDestroy(){
        this.listenMouseDown();
        this.popperAddVar && this.popperAddVar.destroy();
    }

    ngAfterViewInit(){
        // this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideMenu(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.popperAdd()
        // this.helper.wait(() => this.popperAdd(), 200);
    }

    //# toggle selection for grouping
    public select = (item: ColumnSelector | AggregationSelector, e?: MouseEvent): void => {
        if (e){
            e.stopPropagation()
        }

        if (this.type === 'grouping'){
            item = (item as ColumnSelector);
            this.selected = (this.selected as ColumnSelector[]);
            if (item.selected) {
                this.selected.forEach((inItem, i, arr) => {
                    if (inItem.id === item.id){
                        arr.splice(i, 1);
                    }
                });
            } else {
                this.selected.push(item);
            }

            item.selected = !item.selected;
        }
    };

    //# add popper for list
    public popperAdd = (): void => {
        // console.log(this.addRef, this.wrpRef, this.mainWrapper.nativeElement.parentElement, 'popperAdd')
        this.popperAddVar = this.helper.popperAdd(this.addRef, this.mainWrapper, this.wrpRef, 'bottom-end', ['bottom-end'], true);
        // this.popperAddVar = new Popper(this.addRef, this.mainWrapper.nativeElement, {
        //     placement: 'left',
        //     modifiers: {
        //         flip: {
        //             behavior: ['right', 'left']
        //         },
        //         preventOverflow: {
        //             boundariesElement: document.body,
        //         },
        //     },
        //     onUpdate: () => console.log('work popper')
        // });
        // this.popperAddVar = new Popper(this.addRef.nativeElement, this.mainWrapper.nativeElement.parentElement, {
        //      placement: 'auto'});
        //this.popperAddVar.options.onUpdate = (data) => console.log(data)
    };

    //# close form, and emit result of selection
    public apply = (command: string): void => {
        if (this.type === 'aggregation') {
            this.selected = (this.selected as AggregationSelector[]);
            this.selected = this.aggregationList.filter(item => this.helper.hasSelectedAg(item));
        }

        switch (command){
            case 'Apply':
                this.close.emit({type: this.type, data: this.selected});
                break;
            case 'Cancel':
                this.close.emit(null);
                break;
        }
        this.show = false;
    }

    //# if we click not in list, it closing and applying
    private hideList = (e: MouseEvent): void => {

        if (this.helper.hideList(this.mainWrapper, e, this.renderer) && this.helper.hideList(this.addRef, e, this.renderer)) {
           this.apply('Apply');
            // this.helper.wait(() => this.apply('Apply'));
        }
    }

    //# remove selection
    public clearAllMain = (command: string): void => {
        switch (command){
            case 'grouping':
                this.selected = [];
                this.groupingList.forEach(item => item.selected = false);
                break;
            case 'aggregations':
                this.aggregationList.forEach(item => {
                    item.data.avg = false;
                    item.data.sum = false;
                    item.data.max = false;
                    item.data.min = false;
                });
                break;
        }
        if (command) {
            this.filterService.setClearGrpAndAgr(command);
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/stocks/components/ag-select-list.component/ag-select-list.component.ts